module.exports = __webpack_public_path__ + "assets/img/2071591928118_.pic_hd.2a03444a.jpg";